/*@flow*/

type Fun = {
  (...args: Array<any>): any,
  displayName: string,
  name: string,
};

export default function getFunctionName(f: Fun): string {
  return f.displayName || f.name || '<function' + f.length + '>';
}
